import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Gastos",
    items: [
      { label: "Conceptos", icon: "far fa-list-alt", href: "/ConceptosGastos", perm: "menu_gastos" },
      { label: "Gastos",    icon: "fas fa-receipt",  href: "/Gastos",          perm: "menu_gastos" },
    ],
  },
];

function BotonesGastos() {
  return (
    <MenuGrid
      title="Gastos"
      subtitle="Administración de gastos y conceptos"
      icon="fas fa-wallet"
      accent={{ color: "#f59e0b", bg: "#fffbeb" }}
      gate="menu_admin"
      sections={SECTIONS}
    />
  );
}

export default BotonesGastos;
